import $ from 'jquery';
import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import Config from '../utils/config';
import '../utils/global';
import { siteService } from '../services/site-service';
import { dispatchAlert, displayRedirectAlert } from '../utils/site-utils';
import * as athenaPopups from '../utils/athenaPopups';
import {AutoRefreshLoginCheckin, StopLoginCheckin, AutoCheckUM, checkWindowInfo, setBodyCss} from '../utils/NewIndexHelp';
import Sportsbook from './sportsbook';
import TransBar from './popupTransBar';
import UMPopup from './uMPopup';
import { GetQueryString, RemoveQueryString, AddQueryString, checkMobileAgent, getFullUrlPath } from '../utils/common';
import { getCookie, setCookie } from '../utils/cookie';
import { IsThirdPartyPopup, PopupThirdPartyDiv, NOpenKenoWindow } from '../thirdParty/NT3rdFun';
import { OpenExchange, OpenAPIStatement } from '../thirdParty/NT3rdFun';
import Label from '../utils/label';
import Alert from './alert';
import {isRestricted, BrowserRestrictWarning} from './BrowserUpgrade';
import ChinaviewTerminate from './ChinaviewTerminate';

let autoUM = 0, autoLoginCheckin = 0;
let gid = Date.now();

//Liva Chat
if (Label.lbl_livechatForNA != '') {
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.text = Label.lbl_livechatForNA;
	console.log(script);
	document.getElementsByTagName('head')[0].appendChild(script);
}

const MenuTabEnum = Object.freeze({
	Sports:0,
	Home:1,
});

const MenuTabMap = new Map([
	['tab02', 0],
	['tab01', 1]
]);

export default function AthenaAppMain () {

	const [SelectedTab, setSelectedTab] = useState("");
	const [ActPara, setActPara] = useState("");
	const [OpenDivType, setOpenDivType] = useState(-1);
	const [WebSkinType, setWebSkinType] = useState('');
	const [JumpToOldView, setJumpToOldView] = useState(false);
	const [ShowBrowserUpgrade, setBrowserUpgrade] = useState(true);
	const isAthena = Config.appConfig.IsAthena;
	const Logined = Config.appConfig.Logined;
	
	useEffect(() => {
		const init = () => {
			displayRedirectAlert();

			if (Config.appConfig.checkWindow) {
				checkWindowInfo();
			}

			
			let finalSkinType = Config.appConfig.webSkinType,
				DivIndex = -1,
				urlpara = '',
				currMainPage = '',
				act_webskintype = GetQueryString('WebSkinType'),
				EnableAsia = Config.appConfig.EnableAsia,
				EnableEuro = Config.appConfig.EnableEuro,
				EnableChinaAsia = Config.appConfig.EnableChinaAsia,
				EnableLicensee2 = Config.appConfig.EnableLicensee2,
				EnableTablet = Config.appConfig.EnableTablet,
				Enable188China = Config.appConfig.Enable188China,
				WebSkinTypeDefault = Config.appConfig.WebSkinTypeDefault,
				targetMenuTab = parseInt(GetQueryString('targetmenutab'));
		
			if(act_webskintype){
				if(act_webskintype === '0' && !EnableAsia) {
					act_webskintype = WebSkinTypeDefault;
				}
				else if(act_webskintype === '1' && !EnableEuro) {
					act_webskintype = WebSkinTypeDefault;
				}
				else if(act_webskintype === '2' && !EnableChinaAsia) {
					act_webskintype = WebSkinTypeDefault;
				}
				else if(act_webskintype === '3' && !EnableLicensee2) {
					act_webskintype = WebSkinTypeDefault;
				}
				else if(act_webskintype === '4' && !EnableTablet) {
					act_webskintype = WebSkinTypeDefault;
				}
				else if(act_webskintype === '6' && !Enable188China) {
					act_webskintype = WebSkinTypeDefault;
				}
				finalSkinType = act_webskintype;
			}
			
			if(finalSkinType === "4") {
				urlpara = window.location.search.replace('?', '');
				urlpara = RemoveQueryString("webskintype", urlpara);
				urlpara = AddQueryString('webskintype=' + finalSkinType, urlpara);
				window.location.href = "EntryIndex/OpenSports?" + urlpara;
			}
			else {
				//API
				currMainPage = "tab02",
				urlpara = window.location.search.replace('?', '');
	
				if(urlpara === "") {
					urlpara = 'webskintype=' + finalSkinType;
				}
				else {
					urlpara = RemoveQueryString("webskintype", urlpara);
					urlpara = AddQueryString('webskintype=' + finalSkinType, urlpara);
				}
			}
		
			if(urlpara.toLowerCase().indexOf('webskintype') === -1) {
				urlpara = urlpara + '&webskintype=' + finalSkinType;
			}

			if(urlpara.toLowerCase().indexOf('lang') === -1) {
				urlpara = urlpara + '&lang=' + Config.appConfig.UserLang;
			}

			switch (targetMenuTab) {
				case MenuTabEnum.Home:
					currMainPage = 'Tab01';
				default:
					break;
			}
			
			gid =  '&gid=' + Config.appConfig.GUID+gid;

			setSelectedTab(currMainPage);
			setActPara(urlpara);
			setOpenDivType(DivIndex);
			setWebSkinType(finalSkinType);
			setCookie(setCurrMainTab, currMainPage);
			setCookie(setShowMainTab, currMainPage);
		}
		init();
	}, [])

	const openKenoLottery = () => {
		let lang = Config.appConfig.UserLang,
			data = JSON.parse(Config.appConfig.KenoLottery),
			msg = Label.lbl_KenoLotteryNoDeposit,
			flashMsg = Label.lbl_KenoLotteryFlashMsg,
			RES_BlockPopMsg = Label.lbl_BlockPopMsg;
		NOpenKenoWindow(lang, data, msg, flashMsg, RES_BlockPopMsg, Config.appConfig.ActStatus);
	}

	const openKenoTableGame = () => {
		let lang = Config.appConfig.UserLang,
			data = JSON.parse(Config.appConfig.TableGame),
			msg = Label.lbl_TableGameNoDeposit,
			flashMsg = Label.lbl_TableGameFlashMsg,
			RES_BlockPopMsg = Label.lbl_BlockPopMsg;
		NOpenKenoWindow(lang, data, msg, flashMsg, RES_BlockPopMsg, Config.appConfig.ActStatus);
	}

	const openNewKenoWindow = () => {
		let lang = Config.appConfig.UserLang,
			data = JSON.parse(Config.appConfig.Keno),
			msg = Label.lbl_KenoNoDeposit,
			flashMsg = Label.lbl_KenoFlashMsg,
			RES_BlockPopMsg = Label.lbl_BlockPopMsg;
		NOpenKenoWindow(lang, data, msg, flashMsg, RES_BlockPopMsg, Config.appConfig.ActStatus);
	}

	const openDepositPage = (opentype) => {
		switch(opentype) {
			case "4":
			case "5":
			case "6":
				OpenAPIStatement(opentype);
			break;
		}
	}

	const openDepositPageFromEvent = (e, obj) => {
		openDepositPage(obj.key);
		//OpenDepositPage(obj.key, Config.appConfig.CustomTitle);
	}

	const selectTab = (id, openType, url, size, switchWebSkinType) => {
		const SelectedTab = id;
		let finalSkinType = WebSkinType || switchWebSkinType;
		const openId = id.toLowerCase().replace('tab', '');
		if (openType === 0 && 
			url.toLowerCase().indexOf('webskintype', 0) > -1
		) {
			url = '?webskintype=' + finalSkinType;
			setWebSkinType(finalSkinType);
			window.setSportsTab = id;
		}else if (openType == 3) { //deep link
			var tabid = window.setSportsTab;
			if (!tabid) {
				tabid = 'Tab02';
			}
		}

		if (
			openType == 0 &&
			url.toLowerCase().indexOf('webskintype', 0) == -1 &&
			id != 'Tab02' &&
			OpenDivType == 5
		) {
			popupDiv(-1);
		}

		switch (openType) {
			case 0: //inner
				if (url.indexOf('?', 0) == -1) {
					url = 'act=' + url;
				} else {
					url = url.replace('?', '');
					const act = GetQueryString('act', url);
					const LastSport = act == '' ? 'act=sports' : 'act=' + act;
					setCookie('setlastsporttype', LastSport);
				}
				setSelectedTab(SelectedTab),
				setActPara(url)
				break;
			case 1: //popup
				url = url.replace('{0}', Config.appConfig.DomainName);
				athenaPopups.AT_openBrWindow(openId, url, size, size);
				break;
			case 2: //exec JS Function
				switch(url){
					case 'OpenExchange':
						OpenExchange(Config.appConfig.ActStatus);
						break;
					case "_OpenNewKenoWindow()":
						openNewKenoWindow();
						break;
					case 'OpenESportsWeb':
						popupDiv("esports");
						break;
				}
				break;
			case 3: //open left menu game
				if (url.indexOf('?', 0) == -1) {
					url = 'act=' + url;
				} else {
					url = url.replace('?', '');
				}
				setActPara(url);
				let tabid = window.setSportsTab;
				if (!tabid) {
					tabid = 'Tab02';
				}
				setSelectedTab(tabid);
				const LastSport = url == '' ? 'act=sports' : url;
				setCookie('setlastsporttype', LastSport);
				break;
		}
	}

	const popupDiv = (type, para1, para2) => {
		if (IsThirdPartyPopup(type)) {
			PopupThirdPartyDiv(type, para1, para2);
		}
		else {
			if (para1 && para2 && (para1 == 'SingUpByOpenSports' || para1 == 'loginByOpenSports')) {
				siteService.callCustomSignAction(Config.appConfig.SiteID, para2);
			}
			if(type === 0) {
				set_ActPara('reg');
			}
			else {
				setOpenDivType(type);
			}
		}
	}

	const set_ActPara = (para) => {
		const menu = Config.appConfig.MenuData;
		if(para === "reg") {
			for (let i = 0; i < menu.length; i++) {
				if ("tab01" === menu[i].TabName.toLowerCase()) {
					selectTab(menu[i].TabName, menu[i].OpenType, para, menu[i].Size);
					setOpenDivType(0);
				}
				return;
			}
		}
		else {
			const innerSwitchAsia = Config.appConfig.InnerSwitchAsia;
			const enableLicensee2 = Config.appConfig.EnableLicensee2;
			const tab = "tab02";
			if(menu) {
				for (let i = 0; i < menu.length; i++) {
					const url = menu[i].URL.toLowerCase();
					var val = enableLicensee2 ? '?webskintype=3' : '?webskintype=0';
					if(!innerSwitchAsia) {
						val = '?webskintype=' + (WebSkinType ? WebSkinType : '0');
					}
					if (url == 'sports' || url == val) {
						if (tab != menu[i].TabName.toLowerCase()) {
							selectTab(menu[i].TabName, menu[i].OpenType, para, menu[i].Size);
						}
						return;
					}
				}
			}
			selectTab('Tab02', 0, para, '1');
		}
	}

	const deepLink = (e, key) => {
		switch(key.act) {
			case "DeepLeague":
				if(document.getElementById("sportsFrame") != null && document.getElementById("sportsFrame") != 'undefined') {
					document.getElementById("sportsFrame").contentWindow.postMessage(
						{
							mode:"dp",
							data :    {
							   leagueid:key.leagueid,
							   sportid:key.sportid,
							   menuType:key.menuType
							}
						}, 
						"*"
					);
				} 
				else {
					set_ActPara(key.sportid + "&leaguekey" + key.leagueid 
					+ "&menuType" + key.menuType + "&" + new Date().getTime());
				}
				break;
			case "NPHP":
				if(document.getElementById("sportsFrame") != null && document.getElementById("sportsFrame") != 'undefined') {
					document.getElementById("sportsFrame").contentWindow.postMessage("enterNPHP", "*");
				} 
				else {
					set_ActPara(key.act + "&" + new Date().getTime());
				}
				break;
			case "Statement":
				if(WebSkinType === '2')
				{
					if(document.getElementById("sportsFrame") != null && document.getElementById("sportsFrame") != 'undefined') {
						document.getElementById("sportsFrame").contentWindow.postMessage("nphpStatement", "*");
					}
					else {
						set_ActPara(key.act + "&" + new Date().getTime());
					}
				} 
				else {
					openDepositPage("5");
				}
				break;
			default:
				set_ActPara(key.act + "&" + new Date().getTime());
				break;
		}
	}

	const changeOddsType = (e, obj) => {
		$.ajax({
			type: 'POST',
			url: getFullUrlPath('EntryIndex/SetOddsType'),
			data: { OddsType: obj.oddsType }
		});
	}

	const changeDarkmode = (e, obj) => {
		$.ajax({
			type: 'POST',
			url: getFullUrlPath('EntryIndex/SetDarkMode'),
			data: { isDarkMode: obj.isDarkMode }
		});
	}

	const changeLanguage = (e, obj) => {
		$.ajax({
			type: 'POST',
			url: getFullUrlPath('ChangeLanguage.aspx'),
			data: { hidSelLang: obj.key, hidIsLogin: Logined },
			success: refreshPage => {
				window.location.href = refreshPage;
			}
		});
	}

	const setStateForSkinType = (e, obj) => {
		if(WebSkinType != obj.key) {
			popupDiv(6);
		}
		let oldWebSkinType = WebSkinType == "" ? GetQueryString('WebSkinType') : WebSkinType;
		try {
			window.parent.postMessage('ChangeWebSkinType:' + obj.key, Config.appConfig.DomainName);
		}
		catch(e){
		}
		if (obj.key === '0') {
			setJumpToOldView(true, () => setJumpToOldView(false));
		}
		if(oldWebSkinType === "1" && obj.key !== "1") {
			if(Config.appConfig.SiteID == "4200800") {
				window.location.href = "../NewIndex?webskintype=" + obj.key;
				return;
			}
		}
		//setWebSkinType(obj.key);
		let tabid = 'Tab02';
		let isInnerSwitchAsia = Config.appConfig.InnerSwitchAsia;
		if(!isInnerSwitchAsia && obj.key === "3") {
			tabid = 'Tab03';
		}
		const url = window.location.href;

		if (window.history.pushState) {
			let newQueryString = "";
			let tmpArray = url.split("?");
			const baseURL = tmpArray[0];
			const queryString = tmpArray[1];
			if (queryString) {
				tmpArray = queryString.split("&");
				tmpArray.forEach(query => {
					if (query.split('=')[0].toLowerCase() != "webskintype") {
						newQueryString += query + "&";
					}
				});
			}

			newQueryString += "webskintype=" + obj.key;
			const newUrl = baseURL + "?" + newQueryString;
			if (obj.key === '7') {
				redirectToGalaxy(obj);
				return;
			}
			if (obj.key === '8') {
				redirectToMars(obj);
				return;
			}
			window.history.pushState({ path: newUrl }, '', newUrl);
			window.history.pushState({ path: newUrl }, '', newUrl);
		}
		
		selectTab(tabid, 0, '?WebSkinType=' + obj.key, 1, obj.key);
	}

	const redirectToMars = (obj) => {
		let quertyString = window.location.search.replace('?', '');
		const tab = getCookie(setCurrMainTab);
		quertyString = RemoveQueryString("webskintype", quertyString);
		quertyString = AddQueryString('webskintype=8', quertyString);
		quertyString = RemoveQueryString("act", quertyString);
		// quertyString = AddQueryString(`act=${obj.sportId}`, quertyString);
		quertyString = RemoveQueryString("types", quertyString);
		quertyString = AddQueryString(`types=${obj.types}`, quertyString);
		if(obj.leagueId){
			quertyString = AddQueryString(`LeagueId=${obj.leagueId}`, quertyString);
		}
		if(obj.sport){
			quertyString = AddQueryString(`SportId=${obj.sport}`, quertyString);
		}
		quertyString = RemoveQueryString("targetmenutab", quertyString);
		quertyString = AddQueryString(`targetmenutab=${MenuTabMap.get(tab.toLowerCase())}`, quertyString);

		let requestUrlString = getFullUrlPath(`NewIndex?${quertyString}`);
		window.location.href = requestUrlString;
	}
	const redirectToGalaxy = (obj) => {
		let quertyString = window.location.search.replace('?', '');
		const tab = getCookie(setCurrMainTab);
		quertyString = RemoveQueryString("webskintype", quertyString);
		quertyString = AddQueryString('webskintype=7', quertyString);
		quertyString = RemoveQueryString("act", quertyString);
		if(obj.sportId === '43' || obj.sportId === '2') { 
			quertyString = AddQueryString(`act=${obj.sportId}`, quertyString);
		}
		quertyString = RemoveQueryString("types", quertyString);
		quertyString = AddQueryString(`types=${obj.types}`, quertyString);
		if(obj.leagueId){
			quertyString = AddQueryString(`LeagueId=${obj.leagueId}`, quertyString);
		}
		if(obj.sport){
			quertyString = AddQueryString(`SportId=${obj.sport}`, quertyString);
		}
		quertyString = RemoveQueryString("targetmenutab", quertyString);
		quertyString = AddQueryString(`targetmenutab=${MenuTabMap.get(tab.toLowerCase())}`, quertyString);
		
		let requestUrlString = getFullUrlPath(`NewIndex?${quertyString}`);
		window.location.href = requestUrlString;
	}

	const openPopupDiv = (e, obj) => {
		popupDiv(obj.key, obj.para1, obj.para2);
	}

	const handleKeyDown = (e) => {
		if (e.keyCode === 27) {
			//// Detect escape key and close dialog window.
			setOpenDivType(-1);
		}
	}

	useEffect(()=>{
		const DidMount = () => {
			$(document.body).on('keydown', handleKeyDown);
			$('#clickBtnBySkinType').on('click', setStateForSkinType);
			$('#clickBtnByPopupType').on('click', openPopupDiv);
			$('#clickBtnByOpenDeposit').on('click', openDepositPageFromEvent);
			$('#clickBtnByStopLoginCheckin').on('click', StopLoginCheckin);
			$('#clickBtnByChangeLanguage').on('click', changeLanguage);
			$('#clickBtnByDeepLink').on('click', deepLink);
			$('#clickBtnByChangeOddsType').on('click', changeOddsType);
			$('#clickBtnByChangeDarkmode').on('click', changeDarkmode);
			$('#clickBtnByOpenKeno').on('click', openNewKenoWindow);
			$('#clickBtnByOpenKenoLotterty').on('click', openKenoLottery);
			$('#clickBtnByOpenKenoTableGame').on('click', openKenoTableGame);
			StopLoginCheckin(autoUM, autoLoginCheckin);
			autoUM = setInterval(AutoCheckUM, 300000); 
			if (Logined) {
				AutoRefreshLoginCheckin(Config.appConfig.CheckURL, Config.appConfig.IUserName, autoUM, autoLoginCheckin);
				autoLoginCheckin = setInterval(() => {
					AutoRefreshLoginCheckin(Config.appConfig.CheckURL, Config.appConfig.IUserName, autoUM, autoLoginCheckin);
				}, 60000);
			}
			else {
				//Display singin, 
			}
					
			// var self = this;
			$(document).ready(() => {
				if (Logined && Config.appConfig.FPSIsUse) {
					let __timerId = setInterval(postFPSTransaction, 2000);
					function postFPSTransaction() {
						const status = $('#fps-script').attr('data-status');
						const __di = document.getElementById('__di');
						const frm = $('#FormFps');
						if (status === 'idle') return;
                        if ((__di && __di.value != '') || status === 'error') {
							$.ajax({
								type: 'POST',
								url: getFullUrlPath('GquIboemfs.aspx'),
								data: frm.serialize()
							});
							clearInterval(__timerId);
						}
					}
				}
			});
			
			changeCss();
		}
		DidMount();
		return()=>{
			$(document.body).off('keydown', handleKeyDown);
			$('#clickBtnBySkinType').off('click', setStateForSkinType);
			$('#clickBtnByPopupType').off('click', openPopupDiv);
			$('#clickBtnByOpenDeposit').off('click', openDepositPageFromEvent);
			$('#clickBtnByStopLoginCheckin').off('click', StopLoginCheckin);
			$('#clickBtnByChangeLanguage').off('click', changeLanguage);
			$('#clickBtnByDeepLink').off('click', deepLink);
			$('#clickBtnByChangeOddsType').off('click', changeOddsType);
			$('#clickBtnByChangeDarkmode').off('click', changeDarkmode);
			$('#clickBtnByOpenKeno').off('click', openNewKenoWindow);
			$('#clickBtnByOpenKenoLotterty').off('click', openKenoLottery);
			$('#clickBtnByOpenKenoTableGame').off('click', openKenoTableGame);
			
			StopLoginCheckin(autoUM, autoLoginCheckin);
		}
	},[changeCss])

	useEffect(()=>{
		changeCss();
	},[SelectedTab, WebSkinType, Config, changeCss])

	const changeCss = () => {
		let css = "";
		if(SelectedTab.toLowerCase() == "tab02" || (!Config.appConfig.InnerSwitchAsia && SelectedTab.toLowerCase() == "tab03"))
		{
			css = SelectedTab + (WebSkinType === '3' ? ' rwd noNews' : '') + (WebSkinType === '1' ? ' rwd noNews noHead' : '');
		}
		else {
			let rwd = Config.appConfig.SwitchRWDTab ? " rwd" : "";
			css = SelectedTab + (WebSkinType === '3' ? rwd : '') + (WebSkinType === '1' ? ' rwd noNews noHead' : '');
		}
		setBodyCss(css, Config.appConfig.UserLang);
	};

	const sportActPara = ActPara + gid;

	return (
		<div className="full-width" onKeyDown={handleKeyDown}>
			<div className='wrapper'>
				{Logined && <UMPopup />}
				<header></header>
				<Sportsbook 
					isAthena={isAthena} 
					paraConfig={sportActPara} 
					webSkinType={WebSkinType} 
					siteBrand={Config.appConfig.SiteBrand}
					popupDiv={popupDiv} 
					openDivType={OpenDivType} 
				/>
				{OpenDivType === 6 && <TransBar popupDiv={popupDiv} />}
				
				{
					Config.appConfig.EnableChinaViewTerminate && WebSkinType == '2' && OpenDivType === -1 && <ChinaviewTerminate></ChinaviewTerminate>
				}
				<Alert />
			</div>
			{isRestricted() && ShowBrowserUpgrade && <BrowserRestrictWarning lang={Config.appConfig.UserLang} toggle={() => {setBrowserUpgrade(false)}}/>}
			<div style={{ display: "none" }} id="clickBtnBySkinType" />
			<div style={{ display: "none" }} id="clickBtnByPopupType" />
			<div style={{ display: "none" }} id="clickBtnByOpenDeposit" />
			<div style={{ display: "none" }} id="clickBtnByStopLoginCheckin" />
			<div style={{ display: "none" }} id="clickBtnByChangeLanguage" />
			<div style={{ display: "none" }} id="clickBtnByDeepLink" />
			<div style={{ display: "none" }} id="clickBtnByChangeOddsType" />
			<div style={{ display: "none" }} id="clickBtnByChangeDarkmode" />
			<div style={{ display: "none" }} id="clickBtnByOpenKeno" />
			<div style={{ display: "none" }} id="clickBtnByOpenKenoLotterty" />
			<div style={{ display: "none" }} id="clickBtnByOpenKenoTableGame" />
		</div>
	);
}

ReactDOM.render(<AthenaAppMain />, document.getElementById("athenaMainContainer"));
